import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import * as ArchiveActions from './archive.actions';
import { ApiArchivePage } from './api-archive-page.model';

const featureKey = 'archive';

export interface ArchiveState extends EntityState<ApiArchivePage> {
  loading: boolean
}

const adapter: EntityAdapter<ApiArchivePage> = createEntityAdapter<ApiArchivePage>({
  selectId: (page: ApiArchivePage) => page.id + '#' + page.language
});

const initialState: ArchiveState = adapter.getInitialState({
  loading: false
});

const reducer = createReducer(
  initialState,

  on(ArchiveActions.loadPageByPath,
    state => ({ ...state, loading: true })
  ),
  on(ArchiveActions.loadPageSuccess,
    (state, action) => adapter.upsertOne(action.page, { ...state, loading: false })
  ),
  on(ArchiveActions.loadPageFailure, ArchiveActions.loadPageNotModified,
    state => ({ ...state, loading: false })
  ),

);

export const ArchiveReducer = {
  featureKey, initialState, reducer,
  ...adapter.getSelectors()
};
